import { DropdownArrow } from '@hendrx/icons/DropdownArrow';
import { SelectProps } from '@mantine/core';
import { Editor } from '@tiptap/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FontFamilyPicker } from 'shared/components/pickers/FontFamilyPicker';

import { useTextStyles } from '../../../../utils/tiptap/useTextStyles';
import { useToolbarSelectStyles } from '../useToolbarSelectStyles';

export type TextFontSizeSelectProps = {
  editor: Editor | null;
};

export function FontFamilySelect(props: TextFontSizeSelectProps) {
  const { editor } = props;

  const { classes, style } = useToolbarSelectStyles({ maxWidth: 100 });
  const { t } = useTranslation('widgets.fontFamilySelect');
  const { getTextStyles } = useTextStyles(editor);

  const [activeFontFamily, setActiveFontFamily] = useState(getTextStyles('fontFamily'));

  useEffect(() => {
    const setFontFamily = () => {
      const activeFontFamily = getTextStyles('fontFamily');
      setActiveFontFamily(activeFontFamily);
    };

    editor?.on('selectionUpdate', setFontFamily);
    editor?.on('update', setFontFamily);

    return () => {
      editor?.off('selectionUpdate', setFontFamily);
      editor?.off('update', setFontFamily);
    };
  }, [editor, getTextStyles]);

  const handleFontFamilyChange = (fontFamily: string) => {
    editor?.commands.setFontFamily(fontFamily);
  };

  return (
    <FontFamilyPicker
      value={activeFontFamily}
      onChange={handleFontFamilyChange as SelectProps['onChange']}
      title={t('title') ?? ''}
      placeholder={t('placeholder') ?? ''}
      leftSection={<DropdownArrow />}
      leftSectionWidth={24}
      leftSectionPointerEvents="auto"
      rightSection={<></>}
      rightSectionWidth={'0px'}
      variant="unstyled"
      style={style}
      classNames={{
        root: classes.selectRoot,
        option: classes.selectItem,
        dropdown: classes.selectDropdown,
        input: classes.selectInput,
        section: classes.selectIcon
      }}
      styles={{ dropdown: style }}
    />
  );
}
